import React, { useState } from "react";

import { Form, FormControlProps } from "react-bootstrap";

import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import styles from "./TextField.module.scss";

type TexfieldProps = {
  label: string;
  name: string;
  rules?: RegisterOptions;
  screenSpan?: "half-screen" | "full-screen";
} & Omit<FormControlProps, "type"> & { type?: "text" | "hidden" | "number" | "date" };

const Texfield = ({
  name,
  label,
  type = "text",
  screenSpan = "half-screen",
  hidden,
  rules,
  ...rest
}: TexfieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const [colour, setColour] = useState("monoGrey3");

  return (
    <>
      <Form.Group hidden={hidden} className={screenSpan === "half-screen" ? styles["span-one-col-in-grid"] : ""}>
        <Form.Label>{label}</Form.Label>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState }) => (
            <Form.Control
              onBlur={field.onBlur}
              onChange={(e) => {
                field.onChange(e);
                if (type === "date") {
                  setColour("monoBlack");
                }
              }}
              value={field.value}
              type={type}
              {...rest}
              className={type === "date" ? styles[colour] : ""}
              isInvalid={fieldState.error !== undefined}
              _ref={field.ref}
            />
          )}
        />
        {errors?.[name]?.message && (
          <Form.Control.Feedback type="invalid">{errors?.[name]?.message.toString()}</Form.Control.Feedback>
        )}
      </Form.Group>
    </>
  );
};

export default Texfield;
